import ApiData from '@/api/class/ApiData'
import { responseType } from 'complex-require/src/Rule'

export type fileRes = responseType<{
  data: {
    id: string // 无
    relativeId: string // 关联id
    filePath: string // 下载url
    fileName: string // 文件名称
    fileSize: string // 文件大小
    filePosition: string // 文件key
    remark: any // 无
    bizType: string // 文件对应位置
  }[]
}>

const fileApi = {
  upload: new ApiData<[FormData], fileRes>({
    name: '文件上传',
    url: 'web/common/upload',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'form',
    data: ['inherit']
  }),
  save: new ApiData<[{
    relativeId: string
    bizType: string
    fileList: any[]
  }], fileRes>({
    name: '保存关联文件',
    url: 'web/common/saveUploadFiles',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  get: new ApiData<[{
    relativeId: string
    bizType?: string
  }], fileRes>({
    name: '文件获取',
    url: 'web/common/getUploadFiles',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  })
}

export default fileApi
